/** Clips whose audio is generated in the browser instead of fetched from the loop API. */
export function isRenderedClip(clip) {
  return Boolean(clip?.isKnockEngine || clip?.isPattern);
}
